module.exports = __webpack_public_path__ + "static/media/pokerlistingscomlogo.108300e7.svg";